import React from "react";

import { View } from "react-native";
import { IconButton, Text } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import useCropperContext from "../context/cropper";
import useEditorContext from "../context/editor";

export default function Header() {
  const { editingMode, initialEditingMode } = useCropperContext();

  const { onBackPress } = useEditorContext();

  const tailwind = useTailwind();

  function getHelperText() {
    switch (editingMode) {
      case "view":
        return `Selecciona "Confirmar" o "Editar"`;
      case "crop":
        if (initialEditingMode === "view") {
          return "Selecciona la proporción para cortar tu imagen.\n\nPuedes expandir o contraer tu selección desde las esquinas.";
        } else {
          return "Selecciona la porción de la imagen que aparecerá en el encabezado de tu tienda.\n\nLa proporción debe ser de 2:1.";
        }
      case "operation-select":
        return "Confirma tus cambios o regresa a la pantalla de edición.";
    }
  }

  return (
    <View style={tailwind("h-36")}>
      <IconButton icon="arrow-left" onPress={onBackPress} />
      <View style={tailwind("flex-1 items-center justify-center mx-4")}>
        <Text variant="bodyMedium" style={tailwind("text-center")}>
          {getHelperText()}
        </Text>
      </View>
    </View>
  );
}
